import { Block, Typography } from '@aloft/toolkit-sui';

import { FieldPath, useWatch } from 'react-hook-form';

import { PropertyGridForm } from '../types.ts';
import { readOnlyFieldTypographyProps } from './consts.ts';
import { PropertyGridFieldProps } from './types.ts';
import { EditableField } from './EditableField.tsx';

export const SoldPriceField = ({
  columnIndex,
  field,
  control,
  getValues,
  setValue,
  colSpan,
}: PropertyGridFieldProps) => {
  const statusFieldName: FieldPath<PropertyGridForm> = `columns.${columnIndex}.propertyData.editableData.transaction.status`;
  const status = useWatch({ control, name: statusFieldName }) as string | undefined;

  if (status && status !== 'SettledSale') {
    return <Block gridColumn={`span ${colSpan}`}><Typography {...readOnlyFieldTypographyProps}>-</Typography></Block>;
  }

  return <EditableField
    columnIndex={columnIndex}
    field={field}
    control={control}
    getValues={getValues}
    setValue={setValue}
    colSpan={colSpan}
  />

};
